module.exports = __webpack_public_path__ + "img/logo-next-blanco.52e6dc0b.png";